const APIS = {
  USER: "/usermanagementservice/api/user/",
  CHECK_USER: "/usermanagementservice/api/user/check-for-user/",
  FIRST_USER: "/usermanagementservice/api/user/create-first-user/",
  TOKEN: "/usermanagementservice/api/token/",
  CLIENT_SETTING: "/projectsettingsservice/api/configuration/",
  FORGET_PASSWORD: "/usermanagementservice/api/user/forget-password/",
  PASSWORD_RESET_SEND_OTP: "/usermanagementservice/api/user/send-otp/",
  USER_PROFILE: "/usermanagementservice/api/user-profile/",
};

export default APIS;
